import form from './form';

export default function (Alpine) {
    Alpine.data('contactsRequest', form);
}
